import { render, staticRenderFns } from "./configAdd.vue?vue&type=template&id=8db70d32&scoped=true&"
import script from "./configAdd.vue?vue&type=script&lang=js&"
export * from "./configAdd.vue?vue&type=script&lang=js&"
import style0 from "./configAdd.vue?vue&type=style&index=0&id=8db70d32&lang=less&scoped=true&"
import style1 from "./configAdd.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db70d32",
  null
  
)

export default component.exports